<template>
  <b-form novalidate>
    <b-form-group label="CPF" label-for="document">
      <b-input-group>
        <b-input
          id="document"
          v-model="form.document"
          type="search"
          placeholder="Informe CPF do cliente"
          :state="validation.document"
        />
        <b-input-group-append>
          <b-button
            variant="primary"
            :disabled="!form.document"
            @click="onSearch"
          >
            <span class="fas fa-search mr-1" /> Pesquisar
          </b-button>
        </b-input-group-append>
        <b-form-invalid-feedback v-if="$v.form.document.$invalid">
          <span v-if="!$v.form.document.required" class="d-block">
            Informe o cliente
          </span>
          <span v-if="!$v.form.document.isValidCPF" class="d-block">
            Informe um CPF validation
          </span>
        </b-form-invalid-feedback>
      </b-input-group>

      <!-- dica padrǜo -->
      <div>
        <small v-if="showSearchHint" class="text-danger">
          Clique em Pesquisar para buscar os dados do cliente
        </small>
      </div>

      <!-- AVISO DISCRETO DE REPORTS -->
      <div v-if="reportsCount > 0" class="mt-2 d-flex align-items-center">
        <i
          class="bi bi-exclamation-triangle-fill me-2"
          style="font-size: 1rem"
        ></i>
        <small>
          Este cliente possui
          <b-badge
            v-b-tooltip.hover
            variant="danger"
            class="mx-1"
            title="Quantidade de reports registrados para este cliente"
          >
            {{ reportsCount }}
          </b-badge>
          {{ reportsCount === 1 ? 'aviso registrado' : 'avisos registrados' }}
        </small>
      </div>
    </b-form-group>

    <fieldset v-if="showCustomerForm">
      <b-form-group label-for="name">
        <template #label>
          <div class="d-flex justify-content-between">
            <span> Nome </span>
            <b-checkbox v-if="form.id" v-model="form.updateCustomer">
              Atualizar dados
            </b-checkbox>
          </div>
        </template>
        <b-form-input
          id="name"
          ref="name"
          v-model="form.name"
          :state="validation.name"
          :disabled="!form.updateCustomer"
        />
        <b-form-invalid-feedback v-if="$v.form.name.$invalid">
          Informe o nome
        </b-form-invalid-feedback>
      </b-form-group>

      <b-row>
        <b-col>
          <b-form-group label="Telefone" label-for="phone">
            <b-form-input
              id="phone"
              v-model="form.phone"
              :disabled="!form.updateCustomer"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="E-mail" label-for="email">
            <b-form-input
              id="email"
              v-model="form.email"
              type="email"
              :disabled="!form.updateCustomer"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </fieldset>

    <b-form-group label="Periodo" label-for="period-id">
      <PeriodSelect
        v-model="form.periodId"
        :store-id="storeId"
        :validation="$v.form.periodId"
      />
      <b-form-invalid-feedback v-if="$v.form.periodId.$invalid">
        Informe o periodo
      </b-form-invalid-feedback>
    </b-form-group>

    <!-- NOVO: select de funcionǭria, vis��vel apenas para contas kiosk -->
    <b-form-group
      v-if="shouldHandleCommissions"
      label="Funcionaria responsavel pela venda"
      label-for="commission-user-store-id"
    >
      <b-form-select
        id="commission-user-store-id"
        v-model="form.commissionUserStoreId"
        :options="commissionUsersOptions"
        :disabled="commissionUsersLoading"
        placeholder="Selecione a funcionaria responsavel"
        :state="
          $v.form.commissionUserStoreId
            ? !$v.form.commissionUserStoreId.$invalid
            : null
        "
      />

      <b-form-invalid-feedback v-if="$v.form.commissionUserStoreId.$invalid">
        Selecione a funcionaria responsavel pela venda
      </b-form-invalid-feedback>
    </b-form-group>
  </b-form>
</template>

<script>
import { isValidCPF } from '@/helpers/validators'
import { required } from 'vuelidate/lib/validators'
import withFormValidation from '@/mixins/withFormValidation'
import PeriodSelect from '@/components/Periods/PeriodSelect'
import withAsyncAction from '@/mixins/withAsyncAction'
import services from '@/services'
import { ROLES } from '@/constants' // ajusta o caminho conforme seu projeto

export default {
  name: 'ToyRentStartModalForm',
  components: { PeriodSelect },
  mixins: [
    withFormValidation({
      // adicionamos commissionUserStoreId pra mixin cuidar do estado/dirt
      fields: ['document', 'name', 'periodId', 'commissionUserStoreId']
    }),
    withAsyncAction({
      key: 'customer',
      fetcher: {
        methodName: 'fetchCustomerByDocument',
        handler: services.customers.fetchCustomerByDocument
      }
    })
  ],
  // usamos fun��ǜo pra poder acessar this.isKiosk na valida��ǜo dinǽmica
  validations() {
    return {
      form: {
        document: { required, isValidCPF },
        name: { required },
        periodId: { required },
        // s�� Ǹ obrigat��rio quando for conta kiosk
        commissionUserStoreId: this.shouldHandleCommissions ? { required } : {}
      }
    }
  },
  props: {
    toy: { type: Object, required: true },
    submitted: { type: Boolean },
    storeId: { type: [String, Number], default: null },
    storeHasCommissions: { type: Boolean, default: null },
    value: { type: Object, required: true }
  },
  data() {
    return {
      showCustomerForm: false,
      dirty: false,
      // contagem de reports encontrados
      reportsCount: 0,

      // op����es ser��o carregadas do backend (/user/commissionable)
      commissionUsersOptions: [],
      commissionUsersLoading: false
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    },
    showSearchHint() {
      const { $dirty, $invalid } = this.$v.form
      return $dirty && !$invalid && !this.showCustomerForm
    },
    isKiosk() {
      const isKiosk = this.$store.getters['store/isKiosk']
      const isAdmin = this.$store.getters['store/isAdmin']
      return isAdmin || isKiosk
    },
    hasCommissions() {
      if (typeof this.storeHasCommissions === 'boolean') {
        return this.storeHasCommissions
      }

      // Se hÁ uma loja selecionada, evitamos cair na loja global atÁ saber o flag.
      if (this.storeHasCommissions === null && this.storeId) {
        return false
      }

      return this.$store.getters['store/hasCommissions']
    },
    shouldHandleCommissions() {
      return this.hasCommissions && this.isKiosk
    }
  },
  watch: {
    storeId(newVal) {
      this.form = {
        ...this.form,
        commissionUserStoreId: null
      }

      if (this.shouldHandleCommissions && newVal) {
        this.fetchCommissionUsers()
      }
    },
    shouldHandleCommissions(newVal) {
      if (newVal) {
        if (this.storeId) {
          this.fetchCommissionUsers()
        }
      } else {
        this.commissionUsersOptions = []
        this.form = {
          ...this.form,
          commissionUserStoreId: null
        }
      }
    }
  },
  mounted() {
    if (typeof this.form.commissionUserStoreId === 'undefined') {
      this.form = {
        ...this.form,
        commissionUserStoreId: null
      }
    }

    if (this.shouldHandleCommissions && this.storeId) {
      this.fetchCommissionUsers()
    }

    if (this.form.document) {
      this.onSearch()
    }
  },
  methods: {
    roleLabel(role) {
      const entry = Object.values(ROLES).find((r) => r.value === role)
      return entry ? entry.text : role
    },

    async fetchCommissionUsers() {
      if (!this.shouldHandleCommissions) return

      this.commissionUsersLoading = true
      this.commissionUsersOptions = []

      try {
        const response = await services.users.fetchCommissionableUsers(
          this.storeId
        )
        const list = (response || []).filter(
          ({ role }) => role === 'employer' || role === 'admin'
        )

        this.commissionUsersOptions = list.map((user) => ({
          value: user.userStoreId,
          text: user.role
            ? `${user.name} (${this.roleLabel(user.role)})`
            : user.name,
          role: user.role
        }))
      } catch (error) {
        console.log('Error fetching commissionable users:', error)
        this.commissionUsersOptions = []
        if (
          error?.response?.status === 400 ||
          error?.response?.status === 401
        ) {
          this.$root.$toast?.error(
            'Nao foi possivel carregar as funcionarias para comissao. Verifique a loja e sua sessao.'
          )
        } else {
          this.$root.$toast?.error(
            'Erro ao carregar funcionarias para comissao.'
          )
        }
      } finally {
        this.commissionUsersLoading = false
      }
    },
    async onSearch() {
      this.$v.form.document.$touch()

      if (!this.$v.form.document.$invalid) {
        try {
          // 1) busca cliente
          const customer = await this.fetchCustomerByDocument(
            this.form.document
          )
          this.updateForm(customer)

          // 2) discretamente busca reports por customerId e atualiza badge
          if (customer?.id) {
            try {
              const { data } =
                await services.customers.fetchCustomerReportsByCustomerId(
                  customer.id
                )
              const list = Array.isArray(data?.data)
                ? data.data
                : Array.isArray(data)
                ? data
                : []
              this.reportsCount = list.length || 0
            } catch (err) {
              // silencioso; nǜo quebra o fluxo de aluguel
              this.reportsCount = 0
            }
          } else {
            this.reportsCount = 0
          }
        } catch (error) {
          if (error?.response?.status === 400) {
            this.form.updateCustomer = true
            setTimeout(() => this.$refs.name.$el.focus(), 100)
            this.$root.$toast.warning(
              'Cliente nǜo encontrado. Preencha os dados para criar um novo cliente'
            )
            this.updateForm()
            this.reportsCount = 0
          }
        } finally {
          this.showCustomerForm = true
        }
      }
    },
    updateForm(customer) {
      this.form = {
        ...this.form,
        id: customer?.id ?? '',
        name: customer?.name ?? '',
        phone: customer?.phone ?? '',
        email: customer?.email ?? ''
      }
    }
  }
}
</script>
